import React from 'react';
import { render } from 'react-dom';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import './sideEffects'
import { Modal, ConfigProvider } from 'antd';
import Loadable from 'react-loadable';
import { IntlProvider, addLocaleData } from 'react-intl';
import { NProgressLoading } from 'components';
import themes from 'themes';
import { isIE } from 'utils';
import './common/utils/index'

const Spin = () => <NProgressLoading />;
const confirm = Modal.confirm;
if (!window.$$context) {
	window.$$context = {};
}
const Home = Loadable({
	loader: () => import('./routes/home'),
	loading: Spin
});

const Login = Loadable({
	loader: () => import('./routes/login'),
	loading: Spin
});

const Support = Loadable({
	loader: () => import('./routes/support'),
	loading: Spin
});

const Update = Loadable({
	loader: () => import('./routes/update'),
	loading: Spin
});

const NotFound = Loadable({
	loader: () => import('./routes/404'),
	loading: Spin,
});

const DashBoard = Loadable({
	loader: () => import('./routes/dashboard'),
	loading: Spin,
});

const Agreement = Loadable({
	loader: () => import('./routes/agreement'),
	loading: Spin,
});

const PasswordReset = Loadable({
	loader: () => import('./routes/password-reset'),
	loading: Spin,
});

// 根据域名匹配主题
if (themes[window.location.host]) {
	themes[window.location.host]();
} else {
	themes.default();
}

if (!global.Intl) { global.Intl = require('intl'); }

// 国际化设置
const { appLocale } = window;
addLocaleData(appLocale.data);

// 定制化 路由离开确认 confirm
const getConfirmation = (message, callback) => {
	if (message.indexOf('+') > -1) {
		confirm({
			title: message.split('+')[0],
			content: (
				<div>
					{message.split('+')[1]}
				</div>
			),
			onOk: () => {
				// eslint-disable-next-line standard/no-callback-literal
				callback(true);
			},
			onCancel: () => {
				// eslint-disable-next-line standard/no-callback-literal
				callback(false);
			}
		});
	} else {
		// eslint-disable-next-line no-alert
		const allowTransition = window.confirm(message);
		callback(allowTransition);
	}
};

class Root extends React.Component {
	render () {
		if (isIE(10, 'lt')) {
			return (
				<Router>
					<Route path="/" component={Support} />
				</Router>
			);
		}
		return (
			<ConfigProvider locale={appLocale.antd}>
				<IntlProvider locale={appLocale.locale} messages={appLocale.messages}>
					<Router getUserConfirmation={getConfirmation}>
						<Switch>
							<Route exact path="/login" component={Login} />
							<Route exact path="/support" component={Support} />
							<Route exact path="/update" component={Update} />
							<Route exact path="/404" component={NotFound} />
							<Route path="/dashboard" component={DashBoard} />
              <Route path="/agreement" component={Agreement} />
							<Route path="/password-reset" component={PasswordReset} />
							<Route path="/" component={Home} />
						</Switch>
					</Router>
				</IntlProvider>
			</ConfigProvider>
		);
	}
}

render(<Root />, document.getElementById('root'));

// module.hot && module.hot.accept(); //开启热更新HMR

// if (isIE(10, 'lt')) window.location.href = "#/support";
// 在生产环境下且网址非ip的情况下设置 document.domain，设为页面的主域
// 例如将 techpark-alpha.lab.everhomes.com 设为 everhomes.com
const host = window.location.hostname;
if (process.env.NODE_ENV === 'production' && !/^\d{2,3}\./.test(host)) {
	document.domain = host.replace(/^.+\.([^.]+\.[^.]+)$/, '$1');
}
